import { render, staticRenderFns } from "./addPageCollection.vue?vue&type=template&id=167ea156&scoped=true&"
import script from "./addPageCollection.vue?vue&type=script&lang=js&"
export * from "./addPageCollection.vue?vue&type=script&lang=js&"
import style0 from "./addPageCollection.vue?vue&type=style&index=0&id=167ea156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ea156",
  null
  
)

export default component.exports